// Cross-platform keyboard shortcuts that don't conflict with browser defaults
// Refer to https://support.google.com/chrome/answer/157179 for more information.
export const SEARCH_SHORTCUT_CONFIG = {
  simple: {
    key: 'k',
    ctrlKey: true,
    metaKey: true
  }
};

export const NEW_COMPANY_SHORTCUT_CONFIG = {
  simple: {
    key: 'a',
    ctrlKey: true,
    metaKey: true
  }
};

export const NEW_FUND_SHORTCUT_CONFIG = {
  simple: {
    key: 'd',
    ctrlKey: true,
    metaKey: true
  }
};

export const EXPAND_COMPANIES_MENU_TIMEOUT = 100;
export const COMPANY_SEARCH_FOCUS_CLICK_TIMEOUT = 200;
